import React, { useState, useEffect, useRef } from "react";
import "./interviewStatusCard.css";
import moment from "moment";
import { ShareDetails } from "./shareDetails";
import { BsEmojiSmile } from "react-icons/bs";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { HiOutlineEmojiSad } from "react-icons/hi";
import { Modal, Button, Tooltip, message } from "antd";
import {
  updateInterview,
  fetchDeclinedReasonsBids,
} from "../../../../../../redux/actions";
import InterviewDrawer from "../../../../../ProfileDetail/InterviewDrawer/interviewDrawer";
import emailBoxIcon from "../../../../../../assets/img/emailBoxIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";

const InterviewStatusCards = (props) => {
  const bidStatus = useSelector((state) => state.messagesReducer.bidStatus);
  const chats = useSelector((state) => state.messagesReducer.chats);
  const [copySuccess, setCopySuccess] = useState("");

  const [DeclineInterviewLoading, setDeclineInterviewLoading] = useState(false);
  const Loading = useSelector((state) => state.updateInterviewReducer.Loading);
  const loading = useSelector((state) => state.updateInterviewReducer.loading);
  const [index, setIndex] = useState(-1);
  const [otherReason, setOtherReason] = useState('');
  const [declineReason, setDeclineReason] = useState('');
  const [disableReasonCheck, setDisableReasonCheck] = useState(true);
  const [submitReasonClicked, setSubmitReasonClicked] = useState(false);
  const [Reschedule, setReschedule] = useState(false);
  const [interviewDrawer, setinterviewDrawer] = useState(false);
  const [reScheduleInterviewHook, setReScheduleInterviewHook] = useState(false);
  const [bidType, setBidType] = useState(false);
  const [Error, setError] = useState(false);
  const inputA = useRef(null);
  const inputN = useRef(null);
  const inputAs = useRef(null);
  const [interview, setInterview] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tooltipCheck, setTooltipCheck] = useState(false);
  const [interviewConfirmed, setInterviewConfirmed] = useState(false);
  const dispatch = useDispatch();

  const declineReasons = [
    {
      id: 1,
      Reason: "Accepted another candidate",
    },
    {
      id: 2,
      Reason: "Not interested in the candidate",
    },
    {
      id: 3,
      Reason: "Not interested in this Job",
    },
    {
      id: 4,
      Reason: "Asking payrate is too high",
    },
  ];

  const declineReasons2 = [
    {
      id: 5,
      Reason: "Skills not a match",
    },
    {
      id: 2,
      Reason: "On Assignment",
    },
    {
      id: 3,
      Reason: "Not interested in the location",
    },
    {
      id: 4,
      Reason: "Estimated pay rate is too low",
    },
  ];

  const [openModal, setOpenShareInterview] = useState(false);
  const shareInterviewDetails = () => {
    setOpenShareInterview(true);
  };

  useEffect(() => {
    let test;
    let id =
      props?.data?.BidCard
        ? props?.data?.BidCard.DeclineReasonId
        : props?.data?.ProposalCard?.DeclineReasonId;
    test = declineReasons?.filter((d) => d?.id == id);
    if (test.length === 0) test = declineReasons2?.filter((d) => d?.id == id);
  }, [props?.data]);

  useEffect(() => {
    if (!Loading) {
      setDeclineInterviewLoading(false);
    }
  }, [Loading]);

  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  console.log("userProfile", userProfile?.AccountId, props?.items?.SenderUser?.AccountId, props?.items?.SenderUser?.MasterAccountId,userProfile)
  const isEmployer= userProfile?.AccountId == props?.items?.SenderUser?.AccountId || userProfile?.MasterAccountId == props?.items?.SenderUser?.MasterAccountId

  const copyToClipBoard = async (copyMe) => {
    try {
      setCopySuccess("Copied!");
      await navigator.clipboard.writeText(copyMe);
    } catch (error) {
      setCopySuccess("Failed to copy!");
    }
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  useEffect(() => {
    setInterview(props?.InterviewCard);
    setBidType(chats?.data?.body[0]?.SourceTypeId);
  }, [chats]);

  useEffect(() => {
    if (props?.status === "Interview rescheduled")
      setReschedule(props?.items?.ReScheduledTimings);
  }, [props?.status]);

  useEffect(() => {
    if (props?.status === "Proposed Interview")
      dispatch(fetchDeclinedReasonsBids("interview"));
  }, [props?.status === "Proposed Interview"]);

  const handleOk = () => {
  };

  const disableHandler = () => {
    try {
      if (bidStatus.includes("Hired")||bidStatus.includes("Interview Cancelled")) {
        return true;
      } else if (props?.items?.InterviewCard?.IsActive === true) {
        return false;
      }  else {
        return true;
      }
    } catch (error) {
      return true;
    }
  };

  const handleReasonSubmit = () => {
    if(otherReason?.length <1 && declineReason?.length<1){
      setSubmitReasonClicked(true);
      return;
    }
    else{
      if(otherReason?.length>0){
        dispatch(
          updateInterview({
            InterviewId: interview?.InterviewId,
            reschedule: true,
            InterviewStatus: "Rejected",
            type: "emp",
            ReasonId: 10,
            DeclineReason:otherReason,
            isDeclined: true
          })
        );
      }
      else{
        dispatch(
          updateInterview({
            InterviewId: interview?.InterviewId,
            reschedule: true,
            InterviewStatus: "Rejected",
            type: "emp",
            ReasonId: 10,
            DeclineReason:declineReason,
            isDeclined: true
          })
        );
      }
      setDeclineInterviewLoading(true)
      setIsModalVisible(false);
      handleOk();
    }
    
  };

  useEffect(()=>{
    if(otherReason?.length>0){
        inputA.current.value = null;
        inputA.current.style.backgroundColor = "white";
        inputA.current.style.backgroundColor = "white";

      }
      setDeclineReason('');
    },[otherReason])

  useEffect(()=>{
    if(otherReason?.length>0 || inputA?.current?.value != null){
      setDisableReasonCheck(false);
    }
    else{
      setDisableReasonCheck(true);
    }
  },[otherReason,inputA])

  const reScheduleInterview = () => {
    setReScheduleInterviewHook(true);
    setinterviewDrawer(true);
  };

  function rejectModalClose(params) {
    setIsModalVisible(false);
  }

  const InterviewDeclineByTalentReason = {
    1: "Accepted another offer",
    3: "Not interested in this Job",
    4: "I would like to reschedule",
  };

  const ProposedInterviewHandle = () => {
    if (index != -1) {
      setError(false);
      dispatch(
        updateInterview({
          InterviewId: interview?.InterviewId,
          ApprovedScheduledTiming: {
            StartTime: moment.utc(
              interview?.ReScheduledTimings[Reschedule][index].StartTime
            ),
            EndTime: moment.utc(
              interview?.ReScheduledTimings[Reschedule][index].EndTime
            ),
          },
          type: "emp",
          InterviewStatus: "Accepted",
          talent: true,
        })
      );
      setIndex(-1);
    } else {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
    }
  };

  const handleDisableShareInterviewButton = () => {
    if (bidStatus.includes("Hired")||bidStatus.includes("Interview Cancelled")) {
      return true;
    } else {
      if (props?.InterviewCard?.interviewShareIsActive === true) {
        return false;
      } else {
        return true;
      }
    }
  };

  return (
    <>
      <InterviewDrawer
        reSchedule={reScheduleInterviewHook}
        interviewId={interview?.InterviewId}
        bid={chats.data?.body[0]?.SecondarySourceId}
        timings={
          reScheduleInterviewHook
            ? interview?.ReScheduledTimings[Reschedule]
            : interview?.Interviews_ScheduledTimings
        }
        open={interviewDrawer}
        close={setinterviewDrawer}
        bidType={bidType}
      />
      <Modal
        title="Decline Interview?"
        onCancel={rejectModalClose}
        visible={isModalVisible}
        footer={null}
      >
        <div style={{color: disableReasonCheck && submitReasonClicked ? '#DB2828' : '#3E3E3E'}}>Please select a reason for cancelling this interview:</div>
        <div
          ref={inputA}
          className="reject-modal-div"
          data-id="Accepted another candidate"
          onClick={(e) => {
            inputA.current.value = "Accepted another candidate";
            inputA.current.style.backgroundColor = "#e4ffec";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "white";
            setDeclineReason('Accepted another candidate')
            setSubmitReasonClicked(false);
          }}
        >
          Accepted Another Candidate
        </div>
        <div
          ref={inputN}
          className="reject-modal-div"
          data-id="Not interested"
          onClick={(e) => {
            inputA.current.value = "Not Interested in the candidate";
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "#e4ffec";
            inputAs.current.style.backgroundColor = "white";
            setDeclineReason('Not Interested in the candidate')
            setSubmitReasonClicked(false);
          }}
        >
          Not Interested
        </div>
        <div
          ref={inputAs}
          className="reject-modal-div"
          data-id="user deactivated account"
          onClick={(e) => {
            inputA.current.value = "Asking Payrate is too high";
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "#e4ffec";
            setDeclineReason('User Deactivated Account')
            setSubmitReasonClicked(false);
          }}
        >
          User Deactivated Account
        </div>
        <div
            className="other-div"
          >
           <h4>Other</h4>
            <div
              data-id="other"
            >
              <TextArea
                showCount
                maxLength={50}
                className="otherReasonInput"
                style={{
                  height: 80,
                  resize: 'none',
                  border: 'solid 1px #d4d4d4',
                  borderRadius: '4px',
                }}
                onChange={(e)=>{setOtherReason(e?.target?.value); setSubmitReasonClicked(false);}}
                placeholder="Please mention the reason"
                value={otherReason}
              />
            </div>
          </div>
        <button 
          className="rejectModalBtn" 
          onClick={() => handleReasonSubmit()}
        >
          Decline Interview
        </button>
      </Modal>
      <div>
        <ShareDetails
          openModal={openModal}
          interviewId={props?.InterviewCard?.InterviewId}
          setOpenShareInterview={setOpenShareInterview}
          onConfirmInterview={() => {
            setInterviewConfirmed(true);
          }}
          bidType={props?.bidType}
        />

        {props.status == "Scheduled Interview" ? ( //|| props.status == "Interview rescheduled"
          <>
            <div style={{display:'flex',alignItems:'center',flexDirection: 'column',textAlign: 'center',justifyContent: 'center',}} >
              <div>
                <strong >Great!</strong>
              </div>
              <div>
               Your interview is scheduled.<br/>
               Here are your interview details.
              </div>
            </div>
            <div style={{margin:'1rem 0 -0.5rem 0'}}>
              <strong>When</strong>
            </div>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "3% 4%",
                marginTop: "3%",
                borderRadius: "4px",
              }}
            >
              <strong>
                {moment(props.InterviewCard?.ApprovedScheduledTiming?.StartTime)
                  .local()
                  .format("dddd, MMMM DD, YYYY")}
              </strong>{" "}
              <br />
              {moment(props.InterviewCard?.ApprovedScheduledTiming?.StartTime)
                .local()
                .format("h:mm A")}{" "}
              -{" "}
              {moment(props.InterviewCard.ApprovedScheduledTiming?.EndTime)
                .local()
                .format("h:mm A")}
            </div>
            <div style={{margin:'1rem 0 -0.5rem 0'}}>
              <strong>Where</strong>
            </div>
            {props.InterviewCard?.InterviewType && (
              <div
                style={{
                  backgroundColor: "#fff",
                  padding: "3% 4%",
                  marginTop: "3%",
                  borderRadius: "4px",
                }}
              >
                
                {props.InterviewCard?.InterviewType == "Onsite"
                  ? props.InterviewCard?.Location
                  : props.InterviewCard?.MeetingURL}
              </div>
            )}
            {(props.InterviewCard?.MeetingURL != null ||
              props.InterviewCard?.Location != null) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  padding: "4% 6%",
                  width: "100%",
                  marginTop: "3%",
                  borderRadius: "4px",
                }}
              >
                {props.InterviewCard?.OnSite == true ? (
                  <div
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "200px",
                      overflow: "hidden",
                    }}
                  >
                    {props.InterviewCard?.Location}
                  </div>
                ) : (
                  <a
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      width: "200px",
                      overflow: "hidden",
                    }}
                    onClick={() => {
                      const regex = /^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
                      if (regex.test(props.InterviewCard?.MeetingURL)) {
                        window.open(
                          props.InterviewCard?.MeetingURL,
                          "_blank",
                          "noreferrer"
                        );
                      } else {
                        message.warning("Link not Valid !");
                      }
                    }}
                  >
                    {props.InterviewCard?.MeetingURL}
                  </a>
                )}
                {!props.InterviewCard?.OnSite && (
                  <Tooltip
                    overlayClassName={'copy-overlay'}
                    title={copySuccess}
                    trigger={`click`}
                    color={"#2db7f5"}
                    open={tooltipCheck}
                    onOpenChange={() => {
                      setTooltipCheck(true);
                      setTimeout(() => {
                        setTooltipCheck(false);
                      }, [500]);
                    }}
                  >
                    <img
                      className="InterviewsCard-model-email-icon"
                      src={emailBoxIcon}
                      alt="emailBoxIcon"
                      onClick={() => {
                        copyToClipBoard(props.InterviewCard?.MeetingURL);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "3.5%",
              }}
            ></div>
          </>
        ) : null}

        {props.status == "Interview Cancelled" && (
          <div>
            <div>
              {!isEmployer? (
                <div>
                  <strong>Interview declined !</strong> <br />
                  {"Interview Declined by the candidate"}
                </div>
              ) : (
                <div>
                  {"You’ve canceled your interview with the candidate."}
                </div>
              )}
            </div>
            <div
              style={{
                background: "#fff",
                padding: "2.5%",
                marginTop: "2%",
                borderRadius: "5px",
              }}
            >
            
              <strong>Reason</strong> <br />
              {isEmployer
                ? props?.items?.InterviewCard?.DeclineReasonId === 10
                  ? props?.items?.InterviewCard.DeclineReason
                  : props?.items?.InterviewCard?.DeclineReasonId === 4
                  ? "Asking payrate is too High"
                  : props?.items?.InterviewCard?.DeclineReasonId === 1
                  ? "Accepted another candidate"
                  : props?.items?.InterviewCard?.DeclineReasonId === 3 
                  ? "Not interested in the candidate"
                  : props?.items?.InterviewCard?.DeclineReasonId === 2 &&
                    "User Deactivated Account"
                  : props?.items?.InterviewCard?.DeclineReasonId === 10
                  ? props?.items?.InterviewCard.DeclineReason
                : InterviewDeclineByTalentReason[
                    props?.items?.InterviewCard.DeclineReasonId
                  ]}
            </div>
          </div>
        )}
      </div>

      {/* ------------------------------------------------ACCEPTED--------------------------------------------------------- */}
      {props.status == "Accepted Interview" && props.accepted && (
        <div className="cardAccepted">
          <span className="cardHeading">
            {!isEmployer
              ? " Great news! The candidate accepted an interview for:"
              : " Great news! you accepted an interview for:"}
          </span>
          <div className="cardTimingsAccepted">
            <div className="dateAndTimingsContainerAccepted">
              <div className="dateText">
                {moment(
                  props.InterviewCard?.ApprovedScheduledTiming?.StartTime
                ).format("dddd, MMMM DD, YYYY")}
              </div>
              <div className="timeText">
                {moment(
                  props.InterviewCard?.ApprovedScheduledTiming?.StartTime
                ).format("h:mm A")}{" "}
                -{" "}
                {moment(
                  props.InterviewCard?.ApprovedScheduledTiming?.EndTime
                ).format("h:mm A")}
              </div>
            </div>
          </div>
          <Button
            className="acceptedCardShareDetailsBtn"
            onClick={() => shareInterviewDetails()}
            disabled={handleDisableShareInterviewButton() || interviewConfirmed}
          >
            {loading == "share-details" ? (
              <LoadingOutlined />
            ) : (
              "Share interview details"
            )}
          </Button>
        </div>
      )}

      {props.status == "Hired" && (
        <div>
          <p>Congrats!You’ve successfully hired a new employee.</p>
        </div>
      )}

      {/* -----------------------------------------PROPOSE INTERVIEW --------------------------------------------- */}

      {(props?.status == "Proposed Interview" ||
        props?.status == "Interview rescheduled") && ( // need to add this card cannot find one
        <div className="card">
          <div className="cardHeading">
            {props.status == "Proposed Interview"
              ? "Propose interview times"
              : "Reschedule interview times"}{" "}
          </div>
          <div className="cardTimings">
            <div className="radioBtnContainer" onClick={() => setIndex(0)}>
              <input
                style={{ cursor: "pointer" }}
                type="radio"
                name="size"
                value="S"
                id="s1"
              />
            </div>
            <div className="dateAndTimingsContainer">
              {props?.items?.ReScheduledTimings != null ? (
                <>
                  <div className="dateText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][0]?.StartTime
                    )
                      .local()
                      .format("dddd, MMMM DD, YYYY")}
                  </div>

                  <div className="timeText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][0]?.StartTime
                    )
                      .local()
                      .format("h:mm A")}{" "}
                    -{" "}
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][0]?.EndTime
                    )
                      .local()
                      .format("h:mm A")}
                  </div>
                </>
              ) : (
                <>
                  <div className="dateText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")
                          .toString()
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")
                          .toString()}
                  </div>
                  <div className="timeText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.items?.Interviews_ScheduledTimings[0]?.EndTime
                        )
                          .local()
                          .format("h:mm A")
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[0]
                            ?.EndTime
                        )
                          .local()
                          .format("h:mm A")}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="cardTimings">
            <div className="radioBtnContainer" onClick={() => setIndex(1)}>
              <input
                style={{ cursor: "pointer" }}
                type="radio"
                name="size"
                value="S"
                id="s2"
              />
            </div>
            <div className="dateAndTimingsContainer">
              {props?.items?.ReScheduledTimings != null ? (
                <>
                  <div className="dateText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][1]?.StartTime
                    )
                      .local()
                      .format("dddd, MMMM DD, YYYY")}
                  </div>

                  <div className="timeText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][1]?.StartTime
                    )
                      .local()
                      .format("h:mm A")}{" "}
                    -{" "}
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][1]?.EndTime
                    )
                      .local()
                      .format("h:mm A")}
                  </div>
                </>
              ) : (
                <>
                  <div className="dateText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[1]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[1]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")}
                  </div>
                  <div className="timeText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[1]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.items?.Interviews_ScheduledTimings[1]?.EndTime
                        )
                          .local()
                          .format("h:mm A")
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[1]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[1]
                            ?.EndTime
                        )
                          .local()
                          .format("h:mm A")}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="cardTimings">
            <div className="radioBtnContainer" onClick={() => setIndex(2)}>
              <input
                style={{ cursor: "pointer" }}
                type="radio"
                name="size"
                value="S"
                id="s3"
              />
            </div>
            <div className="dateAndTimingsContainer">
              {props?.items?.ReScheduledTimings != null ? (
                <>
                  <div className="dateText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][2]?.StartTime
                    )
                      .local()
                      .format("dddd, MMMM DD, YYYY")
                      .toString()}
                  </div>

                  <div className="timeText">
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][2]?.StartTime
                    )
                      .local()
                      .format("h:mm A")}{" "}
                    -{" "}
                    {moment(
                      props?.InterviewCard?.ReScheduledTimings?.length &&
                        props?.InterviewCard?.ReScheduledTimings[
                          props?.items?.ReScheduledTimings
                        ][2]?.EndTime
                    )
                      .local()
                      .format("h:mm A")}
                  </div>
                </>
              ) : (
                <>
                  <div className="dateText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[2]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[2]
                            ?.StartTime
                        )
                          .local()
                          .format("dddd, MMMM DD, YYYY")}
                  </div>
                  <div className="timeText">
                    {props?.items?.Interviews_ScheduledTimings?.length > 0
                      ? moment(
                          props?.items?.Interviews_ScheduledTimings[2]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.items?.Interviews_ScheduledTimings[2]?.EndTime
                        )
                          .local()
                          .format("h:mm A")
                      : moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[2]
                            ?.StartTime
                        )
                          .local()
                          .format("h:mm A") +
                        " - " +
                        moment(
                          props?.InterviewCard?.Interviews_ScheduledTimings[2]
                            ?.EndTime
                        )
                          .local()
                          .format("h:mm A")}
                  </div>
                </>
              )}
            </div>
          </div>
          {Error && (
            <p style={{ color: "red", fontSize: "15px", marginBottom: "0px" }}>
              Please select a date
            </p>
          )}
          <div
            className={
              props.type === "reschedule"
                ? "proposed-buttons-rescheduled"
                : "proposed-buttons-div"
            }
          >
            {!isEmployer && (
              <div className="proposed-buttons">
                {props.type === "reschedule" ? null : (
                  <>
                    <div className="accept-and-decline">
                      <div
                        className={`decline ${
                          (props.items?.Rank > 6 
                             ) &&
                          " interested-decline"
                        }`}
                        onClick={() => {
                          showModal();
                        
                        }}
                      >
                        <Button
                          className="decline-interview-btn"
                          disabled={
                            disableHandler()
                          }
                        >
                          {Loading && DeclineInterviewLoading ? (
                              <LoadingOutlined />
                            ) : props.items?.Rank === 8 
                            ? "Declined"
                            : "Decline"}
                        </Button>
                      </div>
                      <div
                        className="accept"
                  
                        onClick={() => {
                       
                          ProposedInterviewHandle();
                        }}
                      >
                        <Button
                          className="interview-accept-btn"
                          disabled={
                            disableHandler()
                          }
                        >
                          {/* // && !rescheduleDisable */}
                          {Loading && !DeclineInterviewLoading && !loading ? <LoadingOutlined /> :
                          (props.items?.Rank > 6 &&
                            !(props.items?.Rank === 8)) 
                            ? "Accepted"
                            : "Accept"}
                        </Button>
                      </div>
                    </div>
                  </>
                )}
                <div className="reschedule-div">
                  <Button
                    disabled={
                      disableHandler()
                    }
                    className="reschedule"
              
                    onClick={() => {
                      reScheduleInterview();
                    }}
                  >
                    {loading ? <LoadingOutlined /> : "Request to reschedule"}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {props.status == "Offer Declined" && (
        <div>
          <div>
            <strong>Rejected!</strong> <br />
            {props.MessageText}
          </div>
          <div
            style={{
              background: "#fff",
              padding: "2.5%",
              marginTop: "2%",
              borderRadius: "5px",
            }}
          >
            <strong>Reason</strong> <br />
            {props.data.BidCard.DeclineReason}
          </div>
        </div>
      )}

      {/* ------------------------------------------------FEEDBACK---------------------------------------------------------  */}

      {props.status == "Share your feedBack" && (
        <div>
          <div className="feebackText">Share your feedback</div>
          <div className="similiContainer">
            <div>
              <BsEmojiSmile className="happy-emoji" />
            </div>
            <div>
              <HiOutlineEmojiSad className="Sad-emoji" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default InterviewStatusCards;
